import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page } from 'components'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useExameGenericoService } from 'hooks/useExameGenericoService'
import {
  Grid,
  Button,
  Card,
  Step,
  Typography,
  Stepper,
  StepLabel,
  CircularProgress,
  CardContent,
  Divider,
} from '@material-ui/core'

import { Quesitos } from '../components/Quesitos'
import { EditorGenerico } from '../components/EditorGenerico/EditorGenerico'
import { HeaderEdicaoExame } from '../components/HeaderEdicaoExame'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  container: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  content: {
    padding: theme.spacing(2),
  },
  downContainer: {
    padding: theme.spacing(2),
  },
  cardHeader: {
    marginLeft: theme.spacing(0),
    paddingLeft: theme.spacing(0),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  quesitoGrupo: {
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  inputQuesito: {
    fontWeight: 'bold',
  },
  fieldGroupFormEspecifico: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.spacing(1),
  },
  formularioEspecifico: {
    paddingTop: theme.spacing(1),
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  itemCheck: {
    marginTop: theme.spacing(4),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  itemGroup: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  botoesFormulario: {
    marginTop: theme.spacing(5),
  },
  textAreaTitle: {
    fontWeight: 'bold',
  },
  divider: {
    margin: theme.spacing(1, 1),
  },
  cabecalhoBotao: {
    margin: theme.spacing(2),
    paddingRight: theme.spacing(3),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '80%',
  },
  formAddVestigio: {
    maxHeight: '70vh',
  },
  dividerBlock: {
    marginTop: '15px',
    marginBottom: '10px',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  contentSplitter: {
    flexGrow: 1,
  },
}))

const getSteps = () => ['Histórico', 'Descrição', 'Discussão', 'Conclusão', 'Quesitos']

export const ExameGenerico = (props) => {
  const { route, carregando } = props
  const exameGenericoService = useExameGenericoService()
  const exameRealizadoService = useExameRealizadoService()
  const classes = useStyles()
  const activeStep = useSelector((state) => state.exameGenerico.activeStep)
  const idsState = useSelector((state) => state.idsState)
  const steps = getSteps()
  const exameGenerico = useSelector((state) => state.exameGenerico.exameGenerico)
  const [disableNextButton, setDisableNextButton] = useState(false)
  const [processandoExameGenerico, setProcessandoExameGenerico] = useState(false)
  const [formHistoricoState, setFormHistoricoState] = useState({
    isValid: false,
    values: {
      historico: '',
    },
    touched: {},
    errors: {},
  })

  const [formDescricaoState, setFormDescricaoState] = useState({
    isValid: false,
    values: {
      descricao: '',
    },
    touched: {},
    errors: {},
  })

  const [formDiscussaoState, setFormDiscussaoState] = useState({
    isValid: false,
    values: {
      discussao: '',
    },
    touched: {},
    errors: {},
  })

  const [formConclusaoState, setFormConclusaoState] = useState({
    isValid: false,
    values: {
      conclusao: '',
    },
    touched: {},
    errors: {},
  })

  const [formQuesitosState, setFormQuesitosState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  useEffect(() => {
    setFormHistoricoState({
      ...formHistoricoState,
      values: {
        ...formHistoricoState.values,
        historico: exameGenerico.historico,
      },
    })
    setFormDescricaoState({
      ...formDescricaoState,
      values: {
        ...formDescricaoState.values,
        descricao: exameGenerico.descricao,
      },
    })
    setFormDiscussaoState({
      ...formDiscussaoState,
      values: {
        ...formDiscussaoState.values,
        discussao: exameGenerico.discussao,
      },
    })
    setFormConclusaoState({
      ...formConclusaoState,
      values: {
        ...formConclusaoState.values,
        conclusao: exameGenerico.conclusao,
      },
    })
    
  }, [exameGenerico])

  const isFormError = () =>
    formHistoricoState.errors.historico ||
    formDescricaoState.errors.descricao ||
    formDiscussaoState.errors.discussao ||
    formConclusaoState.errors.conclusao

  useEffect(() => {
    exameGenericoService.listarExameGenericoGlobal(
      idsState.idExameRealizado,
      setProcessandoExameGenerico
    )
    exameGenericoService.setActiveStepExameGenerico(0)

    
  }, [])

  const handleNext = async () => {
    switch (activeStep) {
      case 0: {
        if (formHistoricoState.values.historico !== exameGenerico.historico) {
          setDisableNextButton(true)
          await exameGenericoService.atualizarExameGenerico(
            exameGenerico.id,
            formHistoricoState.values,
            setProcessandoExameGenerico
          )
          setDisableNextButton(false)
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        } else {
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        }
        break
      }
      case 1: {
        if (formDescricaoState.values.descricao !== exameGenerico.descricao) {
          setDisableNextButton(true)
          await exameGenericoService.atualizarExameGenerico(
            exameGenerico.id,
            formDescricaoState.values,
            setProcessandoExameGenerico
          )
          setDisableNextButton(false)
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        } else {
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        }
        break
      }
      case 2: {
        if (formDiscussaoState.values.discussao !== exameGenerico.discussao) {
          setDisableNextButton(true)
          await exameGenericoService.atualizarExameGenerico(
            exameGenerico.id,
            formDiscussaoState.values,
            setProcessandoExameGenerico
          )
          setDisableNextButton(false)
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        } else {
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        }
        break
      }
      case 3: {
        if (formConclusaoState.values.conclusao !== exameGenerico.conclusao) {
          setDisableNextButton(true)
          await exameGenericoService.atualizarExameGenerico(
            exameGenerico.id,
            formConclusaoState.values,
            setProcessandoExameGenerico
          )
          setDisableNextButton(false)
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        } else {
          exameGenericoService.setActiveStepExameGenerico(activeStep + 1)
        }
        break
      }
      case 4: {
        setDisableNextButton(true)
        await exameRealizadoService.responderQuesitosEGerarDocumento(
          exameGenerico.id,
          formQuesitosState.values
        )
        setDisableNextButton(false)
        break
      }
      default: {
        break
      }
    }
  }

  const handleBack = () => {
    if (activeStep > 0) {
      exameGenericoService.setActiveStepExameGenerico(activeStep - 1)
    }
  }

  const getStepTitle = () => {
    switch (activeStep) {
      case 0: {
        return 'Histórico'
      }
      case 1: {
        return 'Descrição'
      }
      case 2: {
        return 'Discussão'
      }
      case 3: {
        return 'Conclusão'
      }
      case 4: {
        return 'Quesitos'
      }
      default:
        return ''
    }
  }

  const getFormContent = () => {
    switch (activeStep) {
      case 0: {
        return (
          <EditorGenerico
            formState={formHistoricoState}
            tituloCampoTexto="Conteúdo do Histórico"
            setFormState={setFormHistoricoState}
            processandoExame={processandoExameGenerico}
            exame={exameGenerico}
            campo="historico"
          />
        )
      }

      case 1: {
        return (
          <EditorGenerico
            formState={formDescricaoState}
            tituloCampoTexto="Conteúdo da Descrição"
            setFormState={setFormDescricaoState}
            processandoExame={processandoExameGenerico}
            exame={exameGenerico}
            campo="descricao"
          />
        )
      }

      case 2: {
        return (
          <EditorGenerico
            formState={formDiscussaoState}
            tituloCampoTexto="Conteúdo da Discussão"
            setFormState={setFormDiscussaoState}
            processandoExame={processandoExameGenerico}
            exame={exameGenerico}
            campo="discussao"
          />
        )
      }

      case 3: {
        return (
          <EditorGenerico
            formState={formConclusaoState}
            tituloCampoTexto="Conteúdo da Conclusão"
            setFormState={setFormConclusaoState}
            processandoExame={processandoExameGenerico}
            exame={exameGenerico}
            campo="conclusao"
          />
        )
      }

      case 4: {
        return (
          <Quesitos
            formState={formQuesitosState}
            setFormState={setFormQuesitosState}
            processandoExame={processandoExameGenerico}
            exame={exameGenerico.exReal}
          />
        )
      }

      default: {
        return null
      }
    }
  }

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <HeaderEdicaoExame
        titulo={`${route.secao}`}
        overline={route.secao}
        isEditorDocumento={false}
      />

      <div className={classes.container}>
        {carregando ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <div>
            <Card className={classes.content}>
              <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <CardContent>
                <Grid
                  container
                  justify="space-between"
                  spacing={3}
                  className={classes.contentSplitter}
                >
                  <Grid item md={12} sm={12} xs={12} spacing={2} className={classes.downContainer}>
                    <Grid container justify="space-between" spacing={1}>
                      <Grid item md={12} sm={12} xs={12}>
                        <Typography component="h4" variant="h4">
                          {getStepTitle()}
                        </Typography>
                      </Grid>
                      <Grid item md={12} sm={12} xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item md={12} sm={12} xs={12}>
                        {getFormContent()}
                      </Grid>
                      <Grid item md={12} sm={12} xs={12}>
                        <Grid
                          container
                          justify="space-between"
                          className={classes.botoesFormulario}
                        >
                          <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            className={classes.backButton}
                          >
                            {activeStep === 0 ? 'Sair da edição' : 'Etapa Anterior'}
                          </Button>

                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            disabled={disableNextButton || isFormError()}
                          >
                            {activeStep === steps.length - 1 ? 'Gerar Documento' : 'Próxima Etapa'}
                            {disableNextButton && (
                              <CircularProgress size={24} className={classes.buttonProgress} />
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    </Page>
  )
}
